/**
 * The global scope context manage storage property expected to be found.
 * This applies on all runtime, e.g. node/browser respectively.
 */
export const GLOBAL_CONTEXT_MANAGER_KEY = '_contextManagerStorage';

/**
 * The context manage storage script markup identifier.
 */
export const CONTEXT_MANAGER_STORAGE_SCRIPT = 'CONTEXT_MANAGER_STORAGE_SCRIPT';
